import React, { Fragment } from "react";

const Layout = ({ children }) => {
  // Define the quantity of Firefly components
  const quantity = 25;

  // Create an array of length 'quantity' filled with null values
  const fireflyIndices = Array.from(
    { length: quantity },
    (_, index) => index + 1
  );
  return (
    <Fragment>
      {/* Map over the array and render a Firefly component for each item */}
      {/* {fireflyIndices.map((index) => (
        <div className="firefly" key={index}></div>
      ))} */}

      <div className="inner-header">
        <div className="signup-space">
          <div className="signup-stars"></div>
          <div className="signup-stars"></div>
          <div className="signup-stars"></div>
          <div className="signup-stars"></div>
          <div className="signup-stars"></div>
          <div className="signup-stars"></div>
        </div>
        {children}
      </div>

      {/* <div>
        <svg
          className="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shapeRendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g className="parallax">
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="0"
              fill="rgba(255,255,255,0.5"
            />
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="3"
              fill="rgba(255,255,255,0.3)"
            />
            <use
              xlinkHref="#gentle-wave"
              x="48"
              y="5"
              fill="rgba(255,255,255,0.5)"
            />
            <use xlinkHref="#gentle-wave" x="48" y="7" fill="#57c0f5ab" />
          </g>
        </svg>
      </div> */}

      <div className="content">{/* <p>Papaya pay </p> */}</div>
    </Fragment>
  );
};

export default Layout;
